var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOffIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9824 17.0148C12.9024 18.7236 15.2544 19.8948 16.368 19.5204C18.384 18.7716 18.72 14.7203 18.72 11.9171C18.72 11.1395 18.72 10.2564 18.6144 9.38281",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8833 6.02517C17.7604 5.65193 17.5624 5.30771 17.3016 5.01384C17.0408 4.71997 16.7225 4.48263 16.3665 4.31634C15.1857 3.87474 12.6801 5.27625 10.6065 7.10985H9.07047C8.05203 7.10985 7.07531 7.51448 6.35518 8.23462C5.63503 8.95476 5.23047 9.93143 5.23047 10.9499V12.8699C5.23016 13.6101 5.44387 14.3349 5.84582 14.9565C6.24778 15.5781 6.82083 16.0703 7.49605 16.3739",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6004 2.32031L2.40039 21.5203",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOffIcon);
export default __webpack_public_path__ + "static/media/SoundOffIcon.4078d9bcb8228438c9698b118e0bd51c.svg";
export { ForwardRef as ReactComponent };